import React from "react";

import { MediaImage } from "@app/scripts/react-general-components/MediaImage";

import type { NormalisedProduct } from "@app/scripts/types";

type Props = {
  product: NormalisedProduct;
};

export const ProductMediaItems: React.FC<Props> = ({ product }) => (
  <>
    {product.media?.map((media) => {
      return (
        <div key={media.id} className="carousel-item">
          <div className="image-container">
            <MediaImage media={media} />
          </div>
        </div>
      );
    })}
  </>
);
